/** Evento disparado após sincronização de datasets / reload de tabelas para descartar cache de catálogo em memória. */
export const RCA_CATALOG_INVALIDATE_EVENT = 'rca-catalog-invalidate';

/**
 * Valores em `sessionStorage`:
 * - `immediate`: reset de cache na próxima oportunidade síncrona (listener ou montagem).
 * - `deferred`: só limpar memória ao voltar à home ou trocar de cliente (evita “sumir” vitrine no meio do fluxo).
 * Legado `'1'` é tratado como `immediate`.
 */
export const RCA_CATALOG_PENDING_INVALIDATE_SESSION_KEY = 'rca_pending_catalog_invalidate';

export const RCA_CATALOG_PENDING_IMMEDIATE = 'immediate';
export const RCA_CATALOG_PENDING_DEFERRED = 'deferred';

export type InvalidateCatalogSyncOptions = {
  /**
   * Quando true, não limpa `PricesContext` na hora se o usuário estiver em fluxo ativo (listener interpreta);
   * sessionStorage fica `deferred` até home ou troca de cliente.
   */
  deferMemoryUntilSafe?: boolean;
};

export type CatalogInvalidateEventDetail = {
  deferMemoryUntilSafe?: boolean;
};

export function parseCatalogPendingInvalidateFlag(raw: string | null): 'immediate' | 'deferred' | null {
  if (!raw) return null;
  if (raw === RCA_CATALOG_PENDING_DEFERRED) return 'deferred';
  return 'immediate';
}

/**
 * Invalida catálogos em cache por cliente/escopo e preços calculados em `PricesContext`.
 * Chamar após `getLinks` / `loadFiles` concluírem e, quando aplicável, após `reloadTables()`.
 */
export function invalidateCatalogCachesAfterSync(options?: InvalidateCatalogSyncOptions): void {
  if (typeof window === 'undefined') return;
  const defer = !!options?.deferMemoryUntilSafe;
  try {
    sessionStorage.setItem(
      RCA_CATALOG_PENDING_INVALIDATE_SESSION_KEY,
      defer ? RCA_CATALOG_PENDING_DEFERRED : RCA_CATALOG_PENDING_IMMEDIATE
    );
  } catch {
    /* ignore quota / private mode */
  }
  window.dispatchEvent(
    new CustomEvent<CatalogInvalidateEventDetail>(RCA_CATALOG_INVALIDATE_EVENT, {
      detail: { deferMemoryUntilSafe: defer },
    })
  );
}
